(function () {
  function initPebbleProductAccordion(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    if (root.dataset.singleOpen !== 'true') return;

    const items = root.querySelectorAll('.pebble-product-accordion__item');
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('.pebble-product-accordion[data-single-open]').forEach(initPebbleProductAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.pebble-product-accordion[data-single-open]').forEach(initPebbleProductAccordion);
  });
})();
